/**
 * MOSA-696 item 5. The email verification code the user types.
 *
 * The api issues 8 symbols out of Crockford base32 (no I, L, O or U), and it
 * keeps accepting the 32 hex characters it sent before the rollout, so both
 * shapes have to pass this screen. The api does the rest of the reading: it
 * folds case, drops the separators, and maps I and L onto 1, O onto 0 and U
 * onto V.
 */
export const SHORT_CODE_LENGTH = 8;

/** Long enough for a legacy code, so a user can still paste one. */
export const MAX_CODE_LENGTH = 32;

const SEPARATORS = /[\s-]+/g;
const SHORT_CODE = /^[0-9A-Z]{8}$/;
const LEGACY_CODE = /^[0-9A-F]{32}$/;

/**
 * What the field holds while the user types: no separators, upper case, and
 * never longer than a legacy code.
 */
export function cleanCodeInput(raw: string): string {
  return raw
    .replace(SEPARATORS, "")
    .toUpperCase()
    .slice(0, MAX_CODE_LENGTH);
}

/** Whether the cleaned value is a code the api can look up. */
export function isCompleteCode(cleaned: string): boolean {
  return SHORT_CODE.test(cleaned) || LEGACY_CODE.test(cleaned);
}
